import { render, staticRenderFns } from "./list.vue?vue&type=template&id=9f5fd37e&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=9f5fd37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5fd37e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f5fd37e')) {
      api.createRecord('9f5fd37e', component.options)
    } else {
      api.reload('9f5fd37e', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=9f5fd37e&scoped=true&", function () {
      api.rerender('9f5fd37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/SBP/list.vue"
export default component.exports